import { z } from "zod";

/** The pain.001 versions a payment file is written in — the current one first. */
export const INCOMING_INVOICE_PAYMENT_FORMATS = ["pain.001.001.09", "pain.001.001.03"] as const;

/**
 * A payment file over the approved invoices picked: whether Skonto still open is taken off, and
 * the pain.001 version the bank software imports. The outgoing invoices offset against a payment
 * are the ones planned on its invoice, so the file asks for none.
 */
export const incomingInvoicePaymentRunSchema = z.object({
	incomingInvoiceIds: z.array(z.string().min(1)).min(1).max(500),
	isSkontoApplied: z.boolean(),
	format: z.enum(INCOMING_INVOICE_PAYMENT_FORMATS),
});

export type IncomingInvoicePaymentRunSchema = z.infer<typeof incomingInvoicePaymentRunSchema>;

/** The export modal's options; the invoices come from the table's selection. */
export const incomingInvoicePaymentRunFormSchema = incomingInvoicePaymentRunSchema.pick({
	isSkontoApplied: true,
	format: true,
});

export type IncomingInvoicePaymentRunFormSchema = z.infer<
	typeof incomingInvoicePaymentRunFormSchema
>;
